import config from '@project/config';

const magazineBaseUrl = `${config.apiUrl}/magazines`;

export default {
  getMagazinesUrl: (page?: number, per?: number) =>
    `${magazineBaseUrl}?page=${page ?? ''}&per=${per ?? ''}`,
  getContentUrl: (id: number) => `${magazineBaseUrl}/${id}/content`,
  getSubscriptionUrl: () => `${magazineBaseUrl}/subscription`,
  subscribeUrl: () => `${magazineBaseUrl}/subscribe`,
  confirmSubscriptionUrl: () => `${magazineBaseUrl}/confirm_subscription`,
  cancelSubscriptionUrl: (id: string) => `${magazineBaseUrl}/subscription/${id}`,
};
